import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <img src={`${process.env.PUBLIC_URL}/lasalle_logo.JPG`} alt="La Salle Tarragona" className="footer-logo" />
          <div>
            <h3>La Salle Tarragona</h3>
            <p>DAM - Desenvolupament d'Aplicacions Multiplataforma</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>1r Curs - Entorns de Desenvolupament</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
